var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索供应商...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSupplier
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSupplier
    }
  }), _vm.currentUser.superAdmin ? _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.ImportSupplierModal.openModal();
      }
    }
  }, [_vm._v("Excel导入供应商")]) : _vm._e(), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateSupplierDrawer();
      }
    }
  }, [_vm._v("新增供应商")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.supplierList,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditSupplierDrawer', {
    ref: "EditSupplierDrawer"
  }), _c('ImportSupplierModal', {
    ref: "ImportSupplierModal"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }